export function buildIsValidDropTarget(targets) {
  const targetsSet = new Set(targets);
  return data => targetsSet.has(data.source);
}